<template>
  <div class="order">
    <div class="container clearfix">
      <div class="category col-12 col-2-t">
        <h2 class="title"><i class="icon-leaf"></i>線上訂購美食</h2>
        <ul class="list">
          <li> 全部 (23)</li>
          <li> 只愛吃薯條 (18)</li>
          <li> 加熱就可食 (1)</li>
          <li class="actived"> 不敗漢堡系列 (4)</li>
        </ul>
      </div>
      <div class="foods col-12 col-10-t">
        <div class="content clearfix">
          <div class="search col-12 col-8-t">
            <div class="group clearfix">
              <input type="text" class="col-10"/><button class="btn col-2"><i class="icon-search"></i></button>
            </div>
          </div>
          <div class="goCart col-12 col-4-t">
            <div class="group clearfix">
              <div class="cart"><i class="icon-cart"></i></div>
              <hr>
              <div class="checkout"><a href="#">結帳去</a></div>
            </div>
          </div>
        </div>
        <div class="products clearfix">
          <div class="product">
            <img src="../assets/product_1.png" height="120" width="300" alt="photo" class="photo">
            <div class="info">
              <h4 class="name">經典漢堡套餐</h4>
              <p class="englishName">Classic Hamburger Package</p>
              <hr>
              <p class="price">$120</p>
              <button class="add">加入購物車</button>
            </div>
            <button class="favourite"><i class="icon-heart-empty"></i></button>
          </div>
          <div class="product">
            <img src="../assets/product_2.png" height="120" width="300" alt="photo" class="photo">
            <div class="info">
              <h4 class="name">英俊香腸</h4>
              <p class="englishName">英俊香腸</p>
              <hr>
              <p class="price">$1,024</p>
              <button class="add">加入購物車</button>
            </div>
            <button class="favourite"><i class="icon-heart-empty"></i></button>
          </div>
          <div class="product">
            <img src="../assets/product_3.png" height="120" width="300" alt="photo" class="photo">
            <div class="info">
              <h4 class="name">漢堡兄弟</h4>
              <p class="englishName">Hamburg Brothers</p>
              <hr>
              <p class="price">$792</p>
              <button class="add">加入購物車</button>
            </div>
            <button class="favourite"><i class="icon-heart-empty"></i></button>
          </div>
          <div class="product">
            <img src="../assets/product_4.png" height="120" width="300" alt="photo" class="photo">
            <div class="info">
              <h4 class="name">完美願望</h4>
              <p class="englishName">Dragon Ball Package</p>
              <hr>
              <p class="price">$999,999</p>
              <button class="add">加入購物車</button>
            </div>
            <button class="favourite"><i class="icon-heart"></i></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'cartPage'
  }
</script>

<style lang="scss" scoped>
  .order {
    padding-top: 50px;
    background-color: #EFE9E7;
  }
  .container {
    width: 90%;
  }
  .category {
    padding-bottom: 23px;
    ul {
      margin-top: 1rem;
      list-style: none;
    }
    li {
      padding: 0 5px;
      border-bottom: 1.5px solid #3D1101;
      line-height: 32px;
      &.actived {
        background-color: #3D1101;
        color: #fff;
      }
    }
    .title {
      font-size: 20px;
      font-weight: normal;
      text-align: left;
      line-height: 32px;
    }
  }
  .search {
    .group {
      height: 32px;
    }
    input {
      height: inherit;
      border: 2px solid #3D1101;
    }
    .btn {
      height: inherit;
      border: none;
      color: #fff;
      background-color: #3D1101;
      font-size: 1.3rem;
    }
  }
  .goCart {
    margin-top: 20px;
    .group {
      height: 32px;
    }
    hr{
      display: inline-block;
      margin:  10px 0 0 0;
      height: 14px;
      border-right: 0 1px 0 0 solid #3D1101;
    }
    hr, .checkout, .cart {
      display: inline-block;
      float: right;
    }
    .checkout {
      padding: 0 12px;
      line-height: 32px;
      a {
        color: #3D1101;
      }
    }
    .cart {
      padding-left: 10px;
      color: #3D1101;
      line-height: 32px;
    }
  }
  .products {
    margin-top: 33px;
  }
  .product {
    position: relative;
    float: left;
    width: 100%;
    margin-bottom: 30px;
    box-shadow: 3px 3px 4px 0px rgba(0,0,0,0.16);
    .photo {
      width: 100%;
    }
    .info {
      padding: 10px;
      text-align: center;
      hr {
        width: 90px;
        margin-top: 8px;
        margin-bottom: 20px;
        border-color: #3D1101; 
        border-bottom: none;
      }
      .name, .englishName, .price {
        color: #3D1101;
      }
      .name {
        font-size: 20px;
      }
      .englishName {
        font-size: 12px;
      }
      .price {
        font-size: 20px;
        font-weight: 700;
      }
      .add {
        width: 95%;
        height: 28px;
        margin-top: 13px;
        border: 2px solid #FF5E45;
        color: #FF5E45;
        background-color: transparent;
        font-size: 1rem;
      }
    }
    .favourite {
      position: absolute;
      top: 0;
      border: none;
      color: #fff;
      background-color: transparent;
      font-size: 1.4rem
    }
  }
  @media (min-width: 768px) {
    .container {
      width: 95%;
    }
    .goCart {
      margin-top: 0;
    }
    .foods {
      padding-left: 1rem;
    }
    .product {
      width: 220px;
      margin-right: 20px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/cartPage.vue